module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA60lEQVR42mNgGAogYQEG3wyI64F4IpQ2Q5N3gIr3Q2l7ajsIZOh/JFxPijwlPteFGn4BzYILUHEZqLoyNPl2WvkcHedD1eVTFAJ4fH4RzeC/aPwDUHXbqBIFJPicEK6nts//EeD/p1YipNTnxDmAAp8Ti8vw2UdLn5OcBqjtcxg+ATVXD29I0MDnxIUEUMIOWm4/IpDPScXo+h9B7bGjt8/xhwRQwAPqsg6oY/ZR2cJ9UHM7oPZ4DM5cgOSAcio7oJyY8mdQhcCoA0YdMOqAUQe0U9kB7UMuBOyhjmiH0uTidpr0DenWC6aH+QAJe21cw8MHLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_uni_con.png
// module id = akc3
// module chunks = 0